import React from 'react';
import abouthome from '../Assets/abouthome.webp'
import { NavLink } from 'react-router-dom';
import './Aboutus.css'
const Aboutus = () => {
  return (
    <div>
        <div className="w-full py-16 bg-white">
  <div className="container mx-auto px-6 lg:px-12 flex flex-col lg:flex-row gap-10 items-stretch">

    {/* Left Side - Image */}
    <div className="lg:w-2/5 w-full flex justify-center items-center">
      <img 
        src={abouthome} 
        alt="About Us" 
        className="w-full h-full object-contain rounded-xl shadow-md"
        style={{ maxHeight: '240px' }}
        onError={(e) => {
          e.target.onerror = null;
          console.error('Error loading about home image');
        }}
      />
    </div>

    {/* Right Side - Description + Button */}
    <div className="lg:w-3/5 w-full flex flex-col justify-between">
      <div className="flex flex-col gap-6">
        <h2 className="text-3xl font-bold text-blue-800">About Us</h2>
        <p className="text-gray-700 leading-relaxed">
          Industrial Automation has been a systems integrator for the past 15+ years, serving a wide variety 
          of manufacturing clients throughout the Midwest. Through the combined experience of our technical 
          staff and business partners we can design and build automated control systems that will increase 
          the safety, quality, productivity, and efficiency of your operation. What's more, we are guided by 
          our Mission, Vision, and Values in how we conduct business and treat our customers and colleagues.
        </p>
      </div>

      {/* Button at the bottom */}
      <div className="mt-6">
        <button className="btn1">
          <NavLink to="/visionmissionvalues">KNOW MORE</NavLink>
        </button>
      </div>
    </div>
  </div>
</div>

    </div>
  )
}

export default Aboutus